import { CreateAppointmentMeta, CreateAppointmentPayload } from 'types/store/CreateAppointment';
import { createAsyncReducer } from 'utils/Redux';

import { createAppointmentActions } from '../actions';

export default createAsyncReducer<CreateAppointmentMeta, CreateAppointmentPayload>(createAppointmentActions);
